/* eslint-disable camelcase */
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import {
  appDefaultContainerSettingFetchInitialized,
  appDefaultContainerSettingFetchSucceeded,
  appDefaultContainerSettingFetchFailed,
} from '../ContainerSettings';
import { SETTING_NAMES } from './appDomainSettings';

type DomainSettingValue = string | { is_enabled: boolean }

export interface DomainSettingsAttributes {
  value: DomainSettingValue
  is_custom: boolean
}

type SettingResponse = {
  data?: {
    type: string
    id: string
    attributes: DomainSettingsAttributes
  }
}

export interface SettingState {
  isLoading: boolean
  failed: boolean
  is_custom: boolean
  value: DomainSettingValue
}

const createInitialState = (value: DomainSettingValue): SettingState => ({
  isLoading: false,
  failed: false,
  value,
  is_custom: false,
});

type SettingStateAndPayload = SettingState & SettingResponse;

const createReducer = (propertyName: string, initialState: SettingState) =>
  handleActions<SettingStateAndPayload>(
    {
      [appDefaultContainerSettingFetchInitialized.toString()]:
      (state: SettingState) => ({
        ...state,
        isLoading: true,
        failed: false,
      }),
      [appDefaultContainerSettingFetchSucceeded.toString()]:
      (state: SettingState, { payload }:
      { payload}) => {
        const attributes = payload.data.find(
          ({ id }) => id === propertyName,
        )?.attributes;

        return {
          ...state,
          isLoading: false,
          value: attributes.value,
          is_custom: attributes.is_custom,
        };
      },
      [appDefaultContainerSettingFetchFailed.toString()]:
      (state: SettingState) => ({
        ...state,
        isLoading: false,
        failed: true,
      }),
    },
    initialState,
  );

const settingsReducer = combineReducers({
  fpc: createReducer(
    SETTING_NAMES.fpc,
    createInitialState({ is_enabled: false }),
  ),
  containerJsPath: createReducer(
    SETTING_NAMES.containerJsPath,
    createInitialState(''),
  ),
  staticResourcesDomain: createReducer(
    SETTING_NAMES.staticResourcesDomain,
    createInitialState(''),
  ),
  trackingDomain: createReducer(
    SETTING_NAMES.trackingDomain,
    createInitialState(''),
  ),
  trackingScriptPath: createReducer(
    SETTING_NAMES.trackingScriptPath,
    createInitialState(''),
  ),
  trackingEndpointPath: createReducer(
    SETTING_NAMES.trackingEndpointPath,
    createInitialState(''),
  ),
  uiApisDomain: createReducer(
    SETTING_NAMES.uiApisDomain,
    createInitialState(''),
  ),
});

export default settingsReducer;
